import { doc, getDoc, setDoc, updateDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { syncLicensePointsWithAuthorized } from '../../utils/pointsCalculator';

export const initializePointsData = async (userId: string, initialPoints: number = 0) => {
  const userRef = doc(db, 'users', userId);
  
  try {
    await setDoc(userRef, {
      points: {
        available: initialPoints,
        lastUpdate: Timestamp.now()
      }
    }, { merge: true });
    
    return {
      available: initialPoints,
      lastUpdate: Timestamp.now()
    };
  } catch (error) {
    console.error('Error initializing points data:', error);
    throw error;
  }
};

export const getPointsData = async (userId: string) => {
  const userRef = doc(db, 'users', userId);
  
  try {
    const userDoc = await getDoc(userRef);
    if (!userDoc.exists()) {
      return null;
    }
    
    const data = userDoc.data();
    
    // Sync points with authorized licenses
    if (data.email) {
      const licensesResponse = await fetch(
        'https://services.shopiweb.fr/api/licenses/get_by_email/premium',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({ email: data.email }).toString()
        }
      );

      const licensesData = await licensesResponse.json();
      const premiumLicenses = licensesData.user?.nbAuthorizedLicenseType?.premium || 0;
      const syncedPoints = await syncLicensePointsWithAuthorized(userId, premiumLicenses);
      
      if (syncedPoints !== data.points?.available) {
        await updatePointsData(userId, syncedPoints);
        return {
          available: syncedPoints,
          lastUpdate: Timestamp.now()
        };
      }
    }
    
    return data.points || null;
  } catch (error) {
    console.error('Error getting points data:', error);
    throw error;
  }
};

export const updatePointsData = async (userId: string, points: number) => {
  const userRef = doc(db, 'users', userId);
  
  try {
    await updateDoc(userRef, {
      'points.available': points,
      'points.lastUpdate': Timestamp.now()
    });
  } catch (error) {
    console.error('Error updating points data:', error);
    throw error;
  }
};